import { paymentMethods } from '~/App/config/paymentMethods';
import { swishTypes } from '~/App/config/swishTypes';

export const schema = {
  'product.id': {
    presence: {
      allowEmpty: false,
      message: '^Ange ett alternativ'
    },
    inclusion: [3, 31]
  },
  'productOptions.product.price': {
    presence: {
      allowEmpty: false,
      message: '^Ange ett belopp'
    },
    numericality: {
      greaterThan: 49,
      lessThanOrEqualTo: 999999,
      message: '^Minsta gåvobelopp är 50 kr'
    }
  },
  'productOptions.customerContact.email': {
    validateEmail: (_, { paymentMethod }) => {
      return paymentMethod.id !== paymentMethods.klarnaPayments;
    }
  },
  'productOptions.customerContact.cid': {
    validateCid: (value, { customerContactType }) =>
      customerContactType === 'company'
  },
  'productOptions.customerContact.company': {
    validateCompany: (value, { customerContactType }) =>
      customerContactType === 'company'
  },
  'productOptions.customerContact.firstName': {
    validateFirstName: (value, { customerContactType, paymentMethod }) =>
      customerContactType === 'manual' ||
      paymentMethod.id === paymentMethods.paymentSlip
  },
  'productOptions.customerContact.lastName': {
    validateLastName: (value, { customerContactType, paymentMethod }) =>
      customerContactType === 'manual' ||
      paymentMethod.id === paymentMethods.paymentSlip
  },
  'productOptions.customerContact.addressStreet': {
    validateStreetName: (value, { customerContactType, paymentMethod }) =>
      customerContactType === 'manual' ||
      paymentMethod.id === paymentMethods.paymentSlip
  },
  'productOptions.customerContact.addressZip': {
    validateZipCode: (value, { customerContactType, paymentMethod }) =>
      customerContactType === 'manual' ||
      paymentMethod.id === paymentMethods.paymentSlip
  },
  'productOptions.customerContact.addressCity': {
    validateCity: (value, { customerContactType, paymentMethod }) =>
      customerContactType === 'manual' ||
      paymentMethod.id === paymentMethods.paymentSlip
  },
  'productOptions.customerContact.phoneNumber': {
    validatePhoneNumber: (value, { customerContactType }) =>
      customerContactType === 'company'
  },
  'klarna.isReady': {
    inclusion: (_, { paymentMethod }) => {
      if (paymentMethod.id === paymentMethods.klarnaPayments) {
        return {
          within: [true],
          message: '^Klarna är inte redo'
        };
      }

      return false;
    }
  },
  swishPhoneNumber: {
    validatePhoneNumber: (_, { paymentMethod, swish }) => {
      if (paymentMethod.id !== 8) {
        return false;
      }

      if (swish.swishType === swishTypes.mcommerce) {
        return false;
      }

      return {
        message: '^Formatet för telefonnummer är 070XXXXXXX'
      };
    }
  },
  'productOptions.customerContact.ssn': {
    validateSsn: (value, { paymentMethod, customerContactType }) => {
      if (paymentMethod.id === paymentMethods.klarnaPayments) {
        return false;
      }

      if (paymentMethod.id === paymentMethods.paymentSlip) {
        return {
          allowEmpty: true
        };
      }

      return (
        customerContactType === 'automatic' ||
        paymentMethod.id === paymentMethods.bankID ||
        paymentMethod.id === paymentMethods.autoGiroBankId
      );
    },
    validateLegalAge: (value, { paymentMethod, customerContactType }) => {
      if (paymentMethod.id === paymentMethods.klarnaPayments) {
        return false;
      }

      return (
        customerContactType === 'automatic' ||
        paymentMethod.id === paymentMethods.bankID ||
        paymentMethod.id === paymentMethods.autoGiroBankId
      );
    }
  },
  'mobileBankId.bank': {
    validateBank: (value, { paymentMethod }) =>
      paymentMethod.id === paymentMethods.bankID ||
      paymentMethod.id === paymentMethods.autoGiroBankId
  },
  'mobileBankId.accountNumber': {
    validateAccountNumber: (value, { paymentMethod }) =>
      paymentMethod.id === paymentMethods.bankID ||
      paymentMethod.id === paymentMethods.autoGiroBankId
  },
  'mobileBankId.clearingNumber': {
    validateClearingNumber: (value, { paymentMethod }) =>
      paymentMethod.id === paymentMethods.bankID ||
      paymentMethod.id === paymentMethods.autoGiroBankId
  },
  'directDebit.deliverPaper': {
    validateDeliverPaper: (value, { paymentMethod }) =>
      paymentMethod.id === paymentMethods.autoGiroSlip
  }
};
